import {useCallback} from 'react';

import {useCommonDataHook} from 'src/hooks/use-common-data-hook';
import {getUserLocale} from 'src/openapi/admin/apis/GetUserLocaleApi';
import {updateUserLocale} from 'src/openapi/admin/apis/UpdateUserLocaleApi';
import {useAppDispatch} from 'src/store/hooks';

import type {SaveOptions} from 'src/components/save-with-reason/save-with-reason-button';
import type {Locale} from 'src/openapi/admin/models/Locale';

export const useFormatSettings = ({userId}: {userId: number}) => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback(() => apiDispatch(
        getUserLocale({userId}),
    ), [userId, apiDispatch]);

    const saveDispatchAction = useCallback((
        locale: Locale,
        signal: AbortSignal,
        options?: SaveOptions,
    ) => apiDispatch(
        updateUserLocale({
            userId,
            userLocaleSaveRequest: {...locale, reason: options?.reason},
        }, {signal}),
    ), [userId, apiDispatch]);

    return useCommonDataHook({
        initValue: {} as Locale,
        getDispatchAction,
        saveDispatchAction,
    });
};
